import ThemeSetting from "./ThemeSetting";

export default ThemeSetting;
